import * as ngCore from '@angular/core'
import type * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'
import { StringCase, transformCase } from '@attain-apps/string-utils'

import * as me from '../../me'

import { getActionsConfig } from './actions'
import type { Api } from './api'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * A {@link store.Feature} that facilitates interaction with an AI assistant
 */
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  /** @see {@link ents.core.agent.Display} */
  public readonly reference: ents.core.agent.Display

  constructor({ api, ...reference }: Feature.constructor.Params) {
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: `${transformCase(reference.id, StringCase.Title)}Assistant`,
      selectors: () => new Selectors(this),
    })

    this.reference = reference
    const meFeature = ngCore.inject(me.Feature)
    this.registerEffects(
      effects.executeAsk(api, meFeature),
      effects.executeGetSuggestedQuestions(api, meFeature),
      effects.triggerGetSuggestedQuestions(meFeature),
    )
  }
}
export namespace Feature {
  export namespace constructor {
    export interface Params extends ents.core.agent.Display {
      readonly api: Api
    }
  }
}
